export const config = {
	COOKIE_CONSENT: 'cookie_consent',
};
